import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  RekapPersetujuanDokterOpsi,
  RekapPersetujuanFilter,
  RekapPersetujuanOpsi,
  RekapPersetujuanResponse
} from "@/types/rekapPersetujuan";

const URL_LAPORAN = "/laporan/rekap-persetujuan-pasien";

interface GalatUnduhan {
  response?: { data?: unknown };
}

function params(filter: RekapPersetujuanFilter) {
  return {
    tgl_start: filter.tgl_start,
    tgl_end: filter.tgl_end,
    q: filter.q ? filter.q.trim() || undefined : undefined,
    keputusan: filter.keputusan,
    jenis_form: filter.jenis_form,
    kelompok: filter.kelompok,
    unit: filter.unit,
    dokter: filter.dokter || undefined
  };
}

function suffix(filter: RekapPersetujuanFilter) {
  return filter.tgl_start === filter.tgl_end
    ? filter.tgl_start
    : `${filter.tgl_start}_${filter.tgl_end}`;
}

async function laporkanGalatBlob(err: GalatUnduhan) {
  const isi = err?.response?.data;

  if (err.response && isi instanceof Blob) {
    try {
      err.response.data = JSON.parse(await isi.text());
    } catch {
      //
    }
  }

  ErrorAlert.showErrorAlert(err);
}

async function opsi(): Promise<RekapPersetujuanOpsi> {
  const res = await http.getData(`${URL_LAPORAN}/opsi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return res.data;
}

async function dokter(): Promise<RekapPersetujuanDokterOpsi[]> {
  const res = await http.getData("/combo/dokter").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const daftar = Array.isArray(res.data) ? res.data : res.data?.data || [];

  return daftar.map((d: { user_id: number; nama: string }) => ({
    user_id: Number(d.user_id),
    nama: d.nama
  }));
}

async function preview(
  filter: RekapPersetujuanFilter,
  page: number,
  perPage: number
): Promise<RekapPersetujuanResponse> {
  const res = await http
    .getDataParam(URL_LAPORAN, {
      params: { ...params(filter), page, per_page: perPage }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data;
}

async function openPdf(filter: RekapPersetujuanFilter): Promise<void> {
  const tab = window.open("", "_blank");

  try {
    const res = await http.getDataParam(`${URL_LAPORAN}/pdf`, {
      params: params(filter),
      responseType: "blob"
    });
    const url = URL.createObjectURL(
      new Blob([res.data], { type: "application/pdf" })
    );

    if (tab) {
      tab.location.href = url;
    } else {
      window.open(url, "_blank");
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (tab) {
      tab.close();
    }
    await laporkanGalatBlob(err as GalatUnduhan);
    return Promise.reject(err);
  }
}

async function downloadExcel(filter: RekapPersetujuanFilter): Promise<void> {
  const res = await http
    .getDataParam(`${URL_LAPORAN}/excel`, {
      params: params(filter),
      responseType: "blob"
    })
    .catch(async err => {
      await laporkanGalatBlob(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `rekap-persetujuan-pasien_${suffix(filter)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

function openFormPdf(pdfPath: string) {
  window.open(`${http.getAPI()}/${pdfPath}`, "_blank");
}

export default {
  opsi,
  dokter,
  preview,
  openPdf,
  downloadExcel,
  openFormPdf
};
